import React from "react";
import Switch from "react-switch";
import styles from "./styles.module.scss";
import xss from "xss";

export type ToggleEvent =
  MouseEvent |
  React.SyntheticEvent<MouseEvent | KeyboardEvent, globalThis.Event>;

export type ToggleEventHandler = (checked: boolean, e: ToggleEvent, id: string) => void;

export type ToggleSwitchConfig = {
  id: string,
  checked: boolean,
  handleToggle: ToggleEventHandler
}

type BancoToggleSwitchProps = {
  config: ToggleSwitchConfig
  htmlClass?: string
}

// ToggleSwitch wraps a react-switch and provides Banco defaults.
export const BancoToggleSwitch = ({
  config,
  htmlClass
}: BancoToggleSwitchProps) => {
  return (
    <Switch
      id={ config.id }
      checked={ config.checked }
      checkedIcon={
        <span className={ `${styles.toggleLabel} ${styles.toggleLabelLeft}` }>On</span>
      }
      className={ xss(htmlClass || "") }
      onChange={ config.handleToggle }
      onColor={ "#23A43D" }
      handleDiameter={ 20 }
      height={ 30 }
      uncheckedIcon={
        <span className={ `${styles.toggleLabel} ${styles.toggleLabelRight}` }>Off</span>
      }
      width={ 65 }
    />
  );
};
